
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Scene,
  PerspectiveCamera,
  WebGLRenderer,
  PCFSoftShadowMap,
  AmbientLight,
  DirectionalLight,
} from 'three'
import { SimpleModel, MODIFICATIONS } from '../../../../Hex-map'

import * as MapSelectors from '../../map.selectors'
import * as Util from '../../../Util/util'
import * as HexUtils from '../../../../Hex-map/util'

class ModelViewer extends React.Component {
  /****/

  constructor(props) {
    super(props)

    this.animate = null
    this.loopId = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.state = {
      currentModel: null,
    }
  }

  componentDidUpdate(prevProps) {
    const { currentModel } = this.state
    const { model, customParams, meshModifications } = this.props
    if (prevProps.model != model) {
      currentModel.onLoadModel = (currentModel) => {
        if (customParams && Object.keys(customParams).length > 0) {
          HexUtils.handleCustomParams(customParams, MODIFICATIONS.TYPE_MESH, (mod) => {
            HexUtils.assignMeshParameters(null, currentModel, mod, meshModifications, true)
          })
        }
      }
      currentModel.load(Util.asset(model))
    }
  }

  componentWillUnmount() {
    // Cancel animation frame
    if (this.loopId) {
      window.cancelAnimationFrame(this.loopId)
      this.loopId = undefined
    }

    // Dispose of Three.js resources properly
    if (this.renderer) {
      this.renderer.dispose()
      this.renderer = null
    }

    if (this.scene) {
      this.scene.clear()
      this.scene = null
    }

    this.camera = null

    this.setState({
      currentModel: null,
    })
  }

  componentDidMount() {
    const { customParams, meshModifications, model } = this.props
    this.camera = new PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 2000)
    this.scene = new Scene()
    let canvas = document.querySelector('#modelViewer')
    let light1 = new AmbientLight(0xffffff, 0.7)
    let light2 = new DirectionalLight(0xffffff, 0.5)
    let customModel = null

    light2.shadow.mapSize.width = 4096
    light2.shadow.mapSize.height = 4096

    this.renderer = new WebGLRenderer({
      canvas: canvas,
      alpha: true,
      antialiasing: true,
      devicePixelRatio: window.devicePixelRatio,
    })

    this.renderer.setClearColor(0x000000, 0)
    this.renderer.shadowMap.enabled = true
    this.renderer.shadowMap.type = PCFSoftShadowMap
    this.camera.castShadow = true

    if (model) {
      let asset = Util.asset(model)
      customModel = new SimpleModel(asset)

      this.scene.add(light1)
      this.scene.add(light2)

      if (customModel) {
        customModel.position.set(0, 0, -30)
        customModel.scale.set(10, 10, 10)
        customModel.rotation.set(0.5, 0, 0)

        if (this.props.customParams) {
          customModel.onLoadModel = (currentModel) => {
            if (customParams && Object.keys(customParams).length > 0) {
              HexUtils.handleCustomParams(customParams, MODIFICATIONS.TYPE_MESH, (mod) => {
                HexUtils.assignMeshParameters(null, currentModel, mod, meshModifications, true)
              })
            }
          }
          this.scene.add(customModel)

          customModel.load(Util.asset(model))
        }

        this.camera.lookAt(customModel.position)
        this.camera.position.set(0, 1, -5)

        this.setState({ currentModel: customModel })
      }
    }

    this.animate = () => {
      if (customModel) {
        customModel.rotation.y += 0.01
      }
      this.renderer.render(this.scene, this.camera)

      this.loopId = requestAnimationFrame(this.animate)
    }

    this.animate()
  }

  /**
   *  Render component
   *  @return {React.Component} The component
   */
  render() {
    const { style } = this.props

    return <canvas style={style} id="modelViewer"></canvas>
  }
}

const mapStateToProps = (state) => ({
  meshModifications: MapSelectors.getMeshModifications(state),
})

ModelViewer.propTypes = {
  model: PropTypes.string,
  customParams: PropTypes.object,
  style: PropTypes.object,
  meshModifications: PropTypes.object,
}

export default connect(mapStateToProps, null)(ModelViewer)
